<template>
  <div v-if="certificate" v-loading="$wait.waiting(_uid)">
    <print-certificate :certificate="certificate" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import PrintCertificate from "@components/Dashboard/Views/Pages/Training/Record/Components/Certificate";

export default {
  components: {
    PrintCertificate,
  },
  data() {
    return {
      certificate: null,
    };
  },
  computed: {
    ...mapGetters("loadingStore", { isLoading: "loading" }),
    routeParams() {
      return this.$route.params;
    },
  },
  async mounted() {
    try {
      this.$wait.start(this._uid);
      this.certificate = await this.getUserCertificate(this.routeParams);
    } catch (error) {
      this.$wait.end(this._uid);
    } finally {
      this.$wait.end(this._uid);
    }
  },
  methods: {
    ...mapActions("loadingStore", ["setLoading"]),
    ...mapActions("errorStore", ["addNewError"]),
    ...mapActions("companyUserStore", ["getUserCertificate"]),
  },
};
</script>

<style lang="scss" scoped></style>
